import { render, staticRenderFns } from "./PageStoreProduct.vue?vue&type=template&id=961c4518&"
import script from "./PageStoreProduct.vue?vue&type=script&lang=js&"
export * from "./PageStoreProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports